import React from "react";
import { Outlet, Navigate, Route, Routes } from "react-router-dom";
import GroceryNavigationBar from "./GroceryNavigationBar";
import PrintSettingsTab from "../configurations/PrintSettingsTab";
import TableBillingTab from "../configurations/TableBillingTab";
import TermsConditionsTab from "../configurations/TermsConditionsTab";
import QRCodesTab from "../configurations/QRCodesTab";
import BusinessOperationTab from "../configurations/BusinessOperationTab";
import FoodTypesTab from "../configurations/FoodTypesTab";
import ReportsTab from "../configurations/ReportsTab";
import NotFound from "../modules/admin/NotFound";
import PrintConfigTab from "../configurations/PrintConfig";
import PosConfig from "../configurations/PosConfig";
import PaymentGatewayConfig from "../configurations/RazorPayConfig";
import PrintConfiguration from "../configurations/commonPrint/PrintConfiguration";

/* ---------------- LAYOUT ---------------- */
const GroceryLayout = () => {
  return (
    <div className='flex w-full h-full p-1'>
      {/* Sidebar */}
      <div className='w-52 h-full'>
        <GroceryNavigationBar />
      </div>

      {/* Page Content */}
      <div className='flex-1 p-4 overflow-auto w-full'>
        <Outlet />
      </div>
    </div>
  );
};

/* ---------------- ROUTES ---------------- */
function GroceryConfigration() {
  return (
    <Routes>
      <Route path='/' element={<GroceryLayout />}>
        {/* Default Redirect */}
        <Route index element={<Navigate to='print-settings' replace />} />
        {/* Tabs */}
        <Route path='print-settings' element={<PrintSettingsTab />} />
        <Route path='pos-config' element={<PosConfig />} />
        <Route path='table-billing' element={<TableBillingTab />} />
        <Route path='terms-conditions' element={<TermsConditionsTab />} />
        <Route path='qr-codes' element={<QRCodesTab />} />
        <Route path='reports' element={<ReportsTab />} />
        <Route path='business-operation' element={<BusinessOperationTab />} />
        <Route path='food-types' element={<FoodTypesTab />} />
        <Route path='print-config' element={<PrintConfigTab />} />
        <Route path='payment-apps' element={<PaymentGatewayConfig />} />
        {/* <Route path='print-layouts' element={<PrintConfiguration />} /> */}


        {/* 404 */}
        <Route path='*' element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default GroceryConfigration;
